import PaymentPlansService from "@/services/PaymentPlansService";
import { replaceItemInList, removeItemFromList } from "@/utils/listHelpers";
import { notifyStoreError } from "@/utils/storeHelpers";
const errorMessages = {
    list: 'Erro ao buscar os planos de pagamento. Tente novamente.',
    create: 'Erro ao adicionar o plano de pagamento. Tente novamente.',
    update: 'Erro ao atualizar o plano de pagamento. Tente novamente.',
    delete: 'Erro ao excluir o plano de pagamento. Tente novamente.',
    duplicate: 'Erro ao duplicar o plano de pagamento. Tente novamente.',
    listMethods: 'Erro ao buscar os métodos vinculados ao plano. Tente novamente.',
    attach: 'Erro ao vincular o método de pagamento. Verifique se o plano já possui um método deste tipo.',
    detach: 'Erro ao desvincular o método de pagamento. Tente novamente.',
};
export default {
    namespaced: true,
    state: {
        paymentPlansData: [],
        status: null,
    },
    getters: {
        getPaymentPlansData: (state) => {
            if (Array.isArray(state.paymentPlansData))
                return state.paymentPlansData;
            if (state.paymentPlansData && state.paymentPlansData.data)
                return state.paymentPlansData.data;
            return [];
        },
        getStatus: (state) => state.status,
    },
    mutations: {
        setPaymentPlansData(state, data) {
            state.paymentPlansData = data;
        },
        setStatus(state, status) {
            state.status = status;
        },
        createPaymentPlanInList(state, paymentPlan) {
            if (!paymentPlan)
                return;
            if (Array.isArray(state.paymentPlansData)) {
                state.paymentPlansData.push(paymentPlan);
            }
            else if (state.paymentPlansData?.data && Array.isArray(state.paymentPlansData.data)) {
                state.paymentPlansData.data.push(paymentPlan);
            }
        },
    },
    actions: {
        async getPaymentPlans({ commit, dispatch }, payload) {
            try {
                const response = await PaymentPlansService.getPaymentPlans(payload.data, payload.userToken);
                commit('setPaymentPlansData', response.data);
            }
            catch (error) {
                commit('setStatus', errorMessages.list);
                notifyStoreError(dispatch, errorMessages.list, error);
            }
            finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true });
                }
            }
        },
        async createPaymentPlan({ commit, dispatch }, payload) {
            try {
                const response = await PaymentPlansService.createPaymentPlan(payload.data, payload.userToken);
                commit('createPaymentPlanInList', response.data);
                dispatch('toastfy/activeSuccesNotification', { text: 'Plano de pagamento adicionado com sucesso' }, { root: true });
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.create, error);
            }
        },
        async updatePaymentPlan({ commit, state, dispatch }, payload) {
            try {
                const response = await PaymentPlansService.updatePaymentPlan(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Plano de pagamento atualizado com sucesso' }, { root: true });
                commit('setPaymentPlansData', replaceItemInList(state.paymentPlansData, response.data));
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.update, error);
            }
        },
        async deletePaymentPlan({ commit, state, dispatch }, payload) {
            try {
                await PaymentPlansService.deletePaymentPlan(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Plano de pagamento deletado com sucesso' }, { root: true });
                commit('setPaymentPlansData', removeItemFromList(state.paymentPlansData, payload.data));
            }
            catch (error) {
                notifyStoreError(dispatch, errorMessages.delete, error);
            }
        },
        async duplicatePaymentPlan({ commit, dispatch }, payload) {
            try {
                const response = await PaymentPlansService.duplicatePaymentPlan(payload.data, payload.userToken);
                commit('createPaymentPlanInList', response.data);
                dispatch('toastfy/activeSuccesNotification', {
                    text: 'Plano duplicado com sucesso — os métodos de pagamento vinculados não são copiados'
                }, { root: true });
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.duplicate, error);
            }
        },
        async getPaymentPlanMethods({ dispatch }, payload) {
            try {
                const response = await PaymentPlansService.getPaymentPlanMethods(payload.paymentPlanId, payload.userToken);
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.listMethods, error);
            }
        },
        async attachPaymentMethod({ commit, state, dispatch }, payload) {
            try {
                const response = await PaymentPlansService.attachPaymentMethod(payload.paymentPlanId, payload.paymentMethodId, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Método de pagamento vinculado com sucesso' }, { root: true });
                commit('setPaymentPlansData', replaceItemInList(state.paymentPlansData, response.data));
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.attach, error);
            }
        },
        async detachPaymentMethod({ commit, state, dispatch }, payload) {
            try {
                const response = await PaymentPlansService.detachPaymentMethod(payload.paymentPlanId, payload.paymentMethodId, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Método de pagamento removido do plano com sucesso' }, { root: true });
                commit('setPaymentPlansData', replaceItemInList(state.paymentPlansData, response.data));
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.detach, error);
            }
        },
    }
};
